<template>
  <svg data-name="Question circle" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
    <path
      data-name="합치기 336"
      d="M0 8.748A8.75 8.75 0 1 1 8.748 17.5 8.747 8.747 0 0 1 0 8.748zm1.248 0a7.5 7.5 0 1 0 7.5-7.5 7.5 7.5 0 0 0-7.5 7.5zm6.564 4.687a.938.938 0 1 1 .936.936.936.936 0 0 1-.936-.935zm.312-2.5V8.123h1.251a1.562 1.562 0 0 0 0-3.123h-.939a1.559 1.559 0 0 0-1.56 1.559v.313H5.624v-.313a2.815 2.815 0 0 1 2.812-2.811h.939a2.812 2.812 0 1 1 0 5.623v1.564z"
      transform="translate(1.251 1.246)"
      style="fill:#585858"
    />
    <path data-name="사각형 147020" style="fill:none" d="M0 0h20v20H0z" />
  </svg>
</template>

<script>
export default {
  name: 'OfficeServiceIcon',
};
</script>
